import { render, staticRenderFns } from "./viewer-ebs-el.vue?vue&type=template&id=1d9477b6&scoped=true"
import script from "./viewer-ebs-el.vue?vue&type=script&lang=js"
export * from "./viewer-ebs-el.vue?vue&type=script&lang=js"
import style0 from "./viewer-ebs-el.vue?vue&type=style&index=0&id=1d9477b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9477b6",
  null
  
)

export default component.exports